"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseCode = exports.Origin = exports.CartType = exports.useCartActions = exports.CartProvider = exports.CartContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const hook_1 = require("./store/actions/hook");
Object.defineProperty(exports, "useCartActions", { enumerable: true, get: function () { return hook_1.useCartActions; } });
Object.defineProperty(exports, "CartContext", { enumerable: true, get: function () { return hook_1.CartContext; } });
const reducers_1 = require("./store/reducers");
const types_1 = require("./types");
Object.defineProperty(exports, "CartType", { enumerable: true, get: function () { return types_1.CartType; } });
Object.defineProperty(exports, "ResponseCode", { enumerable: true, get: function () { return types_1.ResponseCode; } });
Object.defineProperty(exports, "Origin", { enumerable: true, get: function () { return types_1.Origin; } });
const CartProvider = ({ children }) => {
    const [state, dispatch] = (0, react_1.useReducer)(reducers_1.reducer, reducers_1.initialState);
    return (0, jsx_runtime_1.jsx)(hook_1.CartContext.Provider, { value: { state, dispatch }, children: children });
};
exports.CartProvider = CartProvider;
exports.default = CartProvider;
